import React, { Component } from 'react';
import { BrowserRouter, Routes, Route,Router } from "react-router-dom";
import './App.css';

import CreateBook from './components/CreateBook';
import ShowBookList from './components/ShowBookList';
import ShowBookDetails from './components/ShowBookDetails';
import UpdateBookInfo from './components/UpdateBookInfo';

class App extends Component {
  render() {
    return (
      <div>
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<ShowBookList/>} />
              <Route path='/create-book' element={<CreateBook/>} />
              <Route path='/edit-book/:id' element={<UpdateBookInfo/>} />
            <Route path='/show-book/:id' element={<ShowBookDetails/>} />
            </Routes>
         </BrowserRouter>
      </div>
    );
  }
}

export default App;